module.exports = __webpack_public_path__ + "static/media/referral_present.4fbb6b59.svg";